// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u-p7","buttons":"styles_buttons__7XrMX"};